export const servicesImageCardsTokens = {
  colors: {
    background: "#f7f9fc",
    card: "#ffffff",
    text: "#061735",
    textSoft: "#25334d",
    muted: "#526071",
    accent: "#075ed6",
    border: "rgba(6, 23, 53, 0.08)",
    badgeBorder: "rgba(7, 94, 214, 0.42)",
    imageFallback: "#edf2f7",
    shadow: "0 16px 36px rgba(6, 23, 53, 0.08)",
    hoverShadow: "0 20px 44px rgba(6, 23, 53, 0.12)",
    scrollbarTrack: "rgba(6, 23, 53, 0.08)",
    scrollbarThumb: "rgba(7, 94, 214, 0.38)",
  },
  radius: {
    card: 8,
    badge: 8,
  },
  spacing: {
    shellY: 54,
    shellX: 24,
    mobileShellY: 40,
    mobileShellX: 16,
    cardGap: 24,
    mobileCardGap: 18,
    contentX: 24,
    contentBottom: 22,
  },
  sizes: {
    maxWidth: 1180,
    cardWidth: 254,
    imageHeight: 164,
    iconSize: 52,
    mobileImageHeight: 138,
    mobileIconSize: 42,
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    overline: {
      fontSize: 12,
      lineHeight: 1,
      fontWeight: 800,
      letterSpacing: 0,
      textTransform: "uppercase" as const,
    },
    title: {
      fontSize: 36,
      lineHeight: 1.14,
      fontWeight: 800,
      letterSpacing: 0,
    },
    text: {
      fontSize: 15,
      lineHeight: 1.58,
      fontWeight: 500,
      letterSpacing: 0,
    },
    tileTitle: {
      fontSize: 16,
      lineHeight: 1.22,
      fontWeight: 800,
      letterSpacing: 0,
    },
    tileText: {
      fontSize: 14,
      lineHeight: 1.56,
      fontWeight: 500,
      letterSpacing: 0,
    },
    cta: {
      fontSize: 12,
      lineHeight: 1,
      fontWeight: 800,
      letterSpacing: 0,
      textTransform: "uppercase" as const,
    },
  },
  motion: {
    image: "transform 420ms ease",
    card: "box-shadow 180ms ease, transform 180ms ease, border-color 180ms ease",
    cta: "transform 180ms ease",
  },
} as const;
